import useStateStore from 'services/store';
import './shoulder-shape.scss';
const shoulderShape = [
  {
    id: 'straight',
    name: 'straight',
    image: 'images/infor/shoulder-straight.webp',
    description: 'Straight',
  },
  {
    id: 'average',
    name: 'average',
    image: 'images/infor/shoulder-normal.webp',
    description: 'Average',
  },
  {
    id: 'sloping',
    name: 'sloping',
    image: 'images/infor/shoulder-sloping.webp',
    description: 'Sloping',
  },
];

const ShoulderShape = () => {
  const { inforStepValues: steps, changeInforStepValues } = useStateStore();
  const handleChangeSteps = (id: string) => {
    changeInforStepValues('shoulder-shape', id);
  };

  return (
    <div className="body-container">
      <div className="infor">
        <div className="title">
          ALRIGHT, LET'S START WITH YOUR SHOULDER SHAPE!
        </div>
        <div className="confirm">
          Which of the following options best describe your body shape?
        </div>
      </div>
      <div className="image-options">
        {shoulderShape.map((shape) => (
          <div
            onClick={() => handleChangeSteps(shape.id)}
            key={shape.id}
            className={`img-option ${
              steps['shoulder-shape'] === shape.id ? 'active' : ''
            }`}
          >
            <div className="img-container">
              <img src={shape.image} alt="" />
            </div>
            <div className="text">{shape.description}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShoulderShape;
